import axios from "axios";
import { KeyPersonDetailsType } from "../pages/types/KeyPersonDetailsType";

export const createKeyPerson = (
  keyPersonDetails: KeyPersonDetailsType,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/create/one/tradexwbench.customer_key_person`,
      {
        params: {
          context: {},
          data: keyPersonDetails,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
